// extracted by mini-css-extract-plugin
export var card = "_px-0";
export var content = "_px-2";
export var details = "_px-3";
export var icon = "_px-1";
export var iconBlue = "_px-5";
export var iconBrand = "_px-4";
export var iconGrayBlue = "_px-6";
export var iconGreen = "_px-7";
export var iconIndigo = "_px-8";
export var iconOrange = "_px-9";
export var iconPurple = "_px-a";
export var iconRed = "_px-b";
export var iconWarning = "_px-c";